import React, { useState } from 'react';
import { Box, Dialog, Skeleton, Typography } from '@mui/material';
import { useMessageMediaAccessQuery } from './useMessageMediaAccessQuery';
import MediaActionsMenu from './MediaActionsMenu';

const ImageMessageContent = ({ media, messageUuid }) => {
  const isReady = media?.status === 'ready';
  const { data, isLoading, isError } = useMessageMediaAccessQuery(messageUuid, Boolean(messageUuid) && isReady);
  const [expanded, setExpanded] = useState(false);
  const imageUrl = data?.url ?? media?.signedUrl;
  const altText = media?.caption || media?.filename || 'Imagem';

  if (imageUrl) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
        <Box
          component="img"
          src={imageUrl}
          alt={altText}
          onClick={() => setExpanded(true)}
          sx={{
            display: 'block',
            maxWidth: { xs: '100%', sm: 320 },
            maxHeight: 360,
            width: 'auto',
            height: 'auto',
            borderRadius: 1,
            cursor: 'zoom-in',
          }}
        />
        <MediaActionsMenu url={imageUrl} filename={media?.filename} />

        <Dialog open={expanded} onClose={() => setExpanded(false)} maxWidth="lg">
          <Box
            component="img"
            src={imageUrl}
            alt={altText}
            onClick={() => setExpanded(false)}
            sx={{ display: 'block', maxWidth: '100%', maxHeight: '90vh', cursor: 'zoom-out' }}
          />
        </Dialog>
      </Box>
    );
  }

  if (media?.status === 'failed' || isError) {
    return <Typography variant="body2">Nao foi possivel carregar a imagem.</Typography>;
  }

  // Anything other than 'ready' (null, 'pending', 'processing') means the
  // media service hasn't finished yet — keep the skeleton until it has.
  if (!isReady || isLoading) {
    return <Skeleton variant="rounded" width={240} height={180} />;
  }

  return <Typography variant="body2">Imagem indisponivel.</Typography>;
};

export default ImageMessageContent;
